import 'slick-carousel';
import { woocommerceFunctions } from './modules/woocommerce';
let $;
$ = require('jquery');


$(function () {


   if ($('.input-dropdown').length) {
      $('.input-dropdown').click(function () {
         $(this).toggleClass("open");
      });

      $('.dropdown-list-item').click(function () {
         $(this).parent().next(".input-counter").val($(this).text());
      });
   };


   if ($('.reviews-slider').length) {
      $('.reviews-slider').slick({
         dots: false,
         infinite: false,
         speed: 300,
         slidesToShow: 1,
         slidesToScroll: 1,
         prevArrow: "<span class='icon icon-arrow_right prev'></span>",
         nextArrow: "<span class='icon icon-arrow_right'></span>",
      });
   };

   if ($('.second-nav .logo').length) {
      $('.second-nav .logo').parent().parent().remove();
   };

   if ($('.header-menu-btn').length) {
      $('.header-menu-btn').click(function () {
         $('.second-nav').toggleClass("open");
      });
   };

   if ($('.header-search-btn').length) {
      let header_search_btn = $('.header-search-btn').find('.icon');
      header_search_btn.click(function () {
         $('.modal-search').addClass('show');
         $('body').addClass('overflow');
         closeModal($('.modal-search'));
      });
   };

   function closeModal(modal) {
      $(document).mouseup(function (e) {
         let div = modal.find('.modal-dialog');
         if (!div.is(e.target)
            && div.has(e.target).length === 0) {
            modal.removeClass('show');
            $('body').removeClass('overflow');
         }
      });
   }

   $(window).scroll(function () {
      var scroll = $(window).scrollTop();
      if (scroll >= 1) {
         $(".header-site").addClass("fixed");
      } else {
         $(".header-site").removeClass("fixed");
      }
   });



   if ($('.product-slider-list').length && $('.product-slider-list-nav').length) {
      
      $('.product-slider-list').slick({
         slidesToShow: 1,
         slidesToScroll: 1,
         arrows: true,
         fade: false,
         adaptiveHeight: false,
         infinite: false,
         useTransform: true,
         speed: 400,
         prevArrow: "<span class='icon icon-arrow_right prev'></span>",
         nextArrow: "<span class='icon icon-arrow_right'></span>",
         cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',
      });

      $('.product-slider-list-nav')
         .on('init', function (event, slick) {
            $('.product-slider-list-nav .slick-slide.slick-current').addClass('is-active');
         })
         .slick({
            slidesToShow: 5,
            slidesToScroll: 5,
            dots: false,
            arrows: false,
            focusOnSelect: false,
            infinite: false,
            speed: 300,
            prevArrow: "<span class='icon icon-arrow_right prev'></span>",
            nextArrow: "<span class='icon icon-arrow_right'></span>",
            responsive: [
               {
                  breakpoint: 1700,
                  settings: {
                     slidesToShow: 4,
                     slidesToScroll: 4,
                  }
               },
               {
                  breakpoint: 1310,
                  settings: {
                     slidesToShow: 5,
                     slidesToScroll: 5,
                  }
               },
               {
                  breakpoint: 991,
                  settings: {
                     slidesToShow: 4,
                     slidesToScroll: 4,
                  }
               },
               {
                  breakpoint: 771,
                  settings: {
                     slidesToShow: 3,
                     slidesToScroll: 3,
                  }
               }
            ]
         });

      $('.product-slider-list').on('afterChange', function (event, slick, currentSlide) {
         $('.product-slider-list-nav').slick('slickGoTo', currentSlide);
         var currrentNavSlideElem = '.product-slider-list-nav .slick-slide[data-slick-index="' + currentSlide + '"]';
         $('.product-slider-list-nav .slick-slide.is-active').removeClass('is-active');
         $(currrentNavSlideElem).addClass('is-active');
      });

      $('.product-slider-list-nav').on('click', '.slick-slide', function (event) {
         event.preventDefault();
         var goToSingleSlide = $(this).data('slick-index');

         $('.product-slider-list').slick('slickGoTo', goToSingleSlide);
      });

      $('.product-slider').removeClass('loading');

   };

   if ($('.accordion').length) {
      $('.accordion .accordion-item').first().find(".accordion-content").slideToggle(0);
      $('.accordion .accordion-item').first().addClass('active');
      $(".accordion-title").click(function () {
         $(this).parent(".accordion-item").toggleClass('active');
         $(this).parent(".accordion-item").find(".accordion-content").slideToggle(400);
         $(this).parent(".accordion-item").prevAll(".accordion-item").find(".accordion-content").slideUp(400);
         $(this).parent(".accordion-item").nextAll(".accordion-item").find(".accordion-content").slideUp(400);
         $(this).parent(".accordion-item").prevAll(".accordion-item").removeClass('active')
         $(this).parent(".accordion-item").nextAll(".accordion-item").removeClass('active')
      });
   };


   woocommerceFunctions();
});
